// extracted by mini-css-extract-plugin
export default {"ctaWrapper":"Sja-z","subtitle":"Tja-z","wrapper":"Uja-z","leftArrow":"Vja-z","rightArrow":"Wja-z"};